import { render, staticRenderFns } from "./ProductWarehouseConfigRow.vue?vue&type=template&id=6fd695b5&"
import script from "./ProductWarehouseConfigRow.vue?vue&type=script&lang=js&"
export * from "./ProductWarehouseConfigRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports